/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import { Link } from 'react-router-dom'
import { Label, Icon, Button, Popup, Loader } from 'semantic-ui-react'
import map from 'lodash/map'
import size from 'lodash/size'

import firebase from '../../../../config/firebase'
import utils from '../../../../utils'

export default class CustomerInfo extends React.PureComponent {
  state = {
    loading: false,
    phoneVisibility: false,
    customerNameVisibility: false,
    deliveredOrderCount: 0,
  }

  getCustomerOrderCount = async () => {
    const { order } = this.props
    const { deliveredOrderCount } = this.state

    if (deliveredOrderCount === 0) this.setState({ loading: true })

    const ref = firebase.database().ref(`deliverees/${order.deliveree}/delivered_order_count`)

    const snapshot = await ref.once('value')
    const count = snapshot.val() || 0

    this.setState({ deliveredOrderCount: count, loading: false })
  }

  onDelivererNameClick = () => {
    const { customerNameVisibility } = this.state

    this.setState({ customerNameVisibility: !customerNameVisibility })
  }

  onPhoneClick = () => {
    const { phoneVisibility } = this.state

    this.setState({ phoneVisibility: !phoneVisibility })
  }

  renderCustomerOrderCount = () => {
    const { order, readOnly } = this.props
    const { deliveredOrderCount, loading } = this.state

    if (loading) {
      return (
        <div style={{ width: 200, textAlign: 'center' }}>
          <Loader active inline="centered" size="tiny" />
        </div>
      )
    }

    return (
      <div style={{ width: 200, textAlign: 'center' }}>
        <p>{deliveredOrderCount} Succeed Orders</p>
        {!readOnly && (
          <Link
            to={{
              pathname: `/customers/${order.tel}/order`,
              state: { uid: order.deliveree },
            }}
          >
            <Button size="tiny"> View Orders </Button>
          </Link>
        )}
      </div>
    )
  }

  renderGroupOrderPopUp = () => {
    const { order } = this.props

    return (
      <div>
        <Popup
          on="click"
          hideOnScroll
          position="top center"
          trigger={
            <Label style={{ marginTop: 3, cursor: 'pointer' }}>
              <Icon name="group" />
              Group Order ({size(order.group_order.joined_users || {})})
            </Label>
          }
        >
          <div style={{ width: 300 }}>
            {map(order.group_order.joined_users || {}, joinedUser => (
              <div key={joinedUser.tel}>
                {`- ${joinedUser.name}${joinedUser.host ? ' (Host)' : ''} (${joinedUser.tel})`}
              </div>
            ))}
          </div>
        </Popup>
      </div>
    )
  }

  render() {
    const { order } = this.props
    const { phoneVisibility, customerNameVisibility } = this.state

    const displayDelivereeName = customerNameVisibility ? order.deliveree_name : 'User Name'

    const orderTel = order.tel || ""
    const displayPhone = phoneVisibility
      ? orderTel
      : orderTel.substring(0, 6) + (orderTel.length === 12 ? 'xxxxxx' : 'xxxxxxx')

    const callableDriverTel = utils.helpers.convertToLocalPhoneNumber(order.tel)

    return (
      <div style={{ marginTop: 3, fontWeight: 'bold' }}>
        <Popup
          trigger={
            <div style={{ cursor: 'pointer', fontSize: 14 }} onClick={this.onDelivererNameClick}>
              {displayDelivereeName}
            </div>
          }
          hoverable
          on="hover"
          hideOnScroll
          position="top center"
          onOpen={this.getCustomerOrderCount}
        >
          {this.renderCustomerOrderCount()}
        </Popup>

        <a href={utils.helpers.convertToCallableLink(callableDriverTel)}>
          <div
            onClick={this.onPhoneClick}
            style={{ cursor: 'pointer', color: 'grey', fontSize: 13 }}
          >
            {displayPhone}
          </div>
        </a>

        {order.is_group_order && this.renderGroupOrderPopUp()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/CustomerInfo.js